import QuestionContentRenderer from "../elements/QuestionContentRenderer";
import QuestionresponseRenderer from "../elements/QuestionresponseRenderer";
import ApplicationEventHub from '../../../../events/applicationEventHub';
export default {
  props: {
    journeyresponse:{required:true, type:Object}
  },
  components:{
    QuestionContentRenderer,
    QuestionresponseRenderer
  },
  computed:{
    question(){
      return this.journeyresponse.questionresponse.question;
    }
  },
  methods:{
    next(){
       ApplicationEventHub.journeyNext();
    },
    back(){
       ApplicationEventHub.journeyBack();
    },
    emitComplete(data){
      this.$emit('complete',data);
    }
  }
}